<div class="d-flex flex-column p-2 ms-auto" style="max-width: 400px;">
  <div class="text-start">
    @if (showPending) {
      <button class="primary" [disabled]="true" matButton><fa-icon [icon]="faAngleDoubleRight"></fa-icon>Pending Approval</button>
    }

    @if (showEdit && !inEditMode()) {
      <button matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Click to Edit the roadmap and goal details." (click)="onSubmit(cfEnum.Edit, 'true')">
        <fa-icon [icon]="faEdit"></fa-icon> Edit This Version
      </button>
    }

    @if (showEdit && inEditMode()) {
      <button matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Saves changes made to the roadmap as a draft.  It won't be submitted for review until your ready."
        (click)="onSubmit(cfEnum.Update, '1')">
        <fa-icon [icon]="faDraftingCompass"></fa-icon>
        @if(showNewVersionText) {
          <span>&nbsp;(New Draft) Save changes</span>
        } @else {
          <span>&nbsp;(Draft) Save changes</span>
        }
      </button>
    }

    @if (showEdit && inEditMode() && showNewVersionText) {
      <p class="chiisai-desc"><i>Create a new version of this roadmap as a draft.</i></p>
    }

    @if (showEdit && !inEditMode()) {
      <button [disabled]="roadmapError()" style="color:#0061a2" matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Submits this Roadmap for review.  You won't be able to make changes until reviewed."
        (click)="onSubmit(cfEnum.Update, '2')" class="primary">
        <fa-icon [icon]="faAngleDoubleRight"></fa-icon>
        @if(showNewVersionText) {
          <span>&nbsp;(New Submit) Submit for Review</span>
        } @else {
          <span>&nbsp;(Submit) Submit for Review</span>
        }
      </button>
    }

    @if (showEdit && !inEditMode() && showNewVersionText) {
      <p class="chiisai-desc"><i>Create a new version of this roadmap and submit it.</i></p>
    }

    @if (showEdit && inEditMode()) {
      <button [disabled]="roadmapError()" matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Save the roadmap changes and submits it for review.  You won't be able to make changes until reviewed."
        (click)="onSubmit(cfEnum.Update, '2')" class="primary">
        <fa-icon [icon]="faAngleDoubleRight"></fa-icon>
        @if(showNewVersionText) {
          <span>&nbsp;(New Submit) Save &amp; Submit</span>
        } @else {
          <span>&nbsp;(Submit) Save &amp; Submit</span>
        }
      </button>
    }

    @if (showEdit && inEditMode() && showNewVersionText) {
      <p class="chiisai-desc"><i>Create a new version of this roadmap and submit it.</i></p>
    }

    @if (showApprove) {
      <button matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Approve of this roadmap version.  Project Team will be notified."
        (click)="onSubmit(cfEnum.Update, '4')">
        <fa-icon [icon]="faUserCheck"></fa-icon>
        <!-- @if(hasRlm() && appUser()?.isMinRlm) {
          <span>&nbsp;(RLM) Approve this version</span>
        } @else if (!hasRlm() && (appUser()?.isAdminUser || appUser()?.isImApprover)) {
          <span>&nbsp;(IA) Approve this version</span>
        } -->
      </button>
    }

    @if (showApproveDryRun) {
      <button class="btn-approve" matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Approve of this roadmap version, will set the Roadmap into Dry Run status.  Project Team and RLM will be notified."
        (click)="onSubmit(cfEnum.Update, '6')">
        <fa-icon [icon]="faUserCheck"></fa-icon>
        (IA) Approve Dry Run version
      </button>
    }

    @if (showReject) {
      <button class="btn-reject" matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Return roadmap version for revision.  The Project Team will be able to revise and resubmit."
        (click)="onSubmit(cfEnum.Update, '3')">
        <fa-icon [icon]="faUserAltSlash"></fa-icon>
        <!-- @if (hasRlm() && appUser()?.isMinRlm) {
          <span>&nbsp;(RLM) Return for Revision</span>
        } @else {
          <span>&nbsp;(IA) Return for Revision</span>
        } -->
      </button>
    }

    <!-- Admin Buttons -->
    @if (showEditAdmin && inEditMode()) {
      <button matButton matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Update the Roadmap and save the changes outside of the normal workflow.  This button is for admins."
        (click)="onSubmit(cfEnum.UpdateAdmin, '2')">
        <fa-icon [icon]="faSpellCheck"></fa-icon>
        (Admin) Update Roadmap
      </button>
    }

    @if (showDeleteAdmin) {
      <button matButton style="color:red" matTooltipPosition="left" matTooltipShowDelay="1000" matTooltip="Click to delete the roadmap and all historical versions.  For admins only... This cannot be undone."
        (click)="onSubmit(cfEnum.Delete)">
        <fa-icon [icon]="faTrash"></fa-icon>
        (Admin) Delete Roadmap
      </button>
    }
  </div>
</div>
